import './App.css';
import 'antd/dist/antd.css';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { Router } from '@reach/router';
import Login from 'pages/login';
import Dashboard from 'pages/home';
import PrivateRoute from 'components/security/privateRoute';
import { theme } from 'layouts/theme';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Login path="/" />
        <PrivateRoute path="/Home" component={Dashboard} />
      </Router>
    </ThemeProvider>
  );
}


export default App;